// Shared DOM-element location infrastructure used by all DOM mutation tools.
// Elements may not exist when a tool first runs (page still rendering), so we
// poll with a fixed retry count + delay before giving up.

export const ELEMENT_RETRY_COUNT = 8
const ELEMENT_RETRY_DELAY_MS = 500

// How long navigate tools wait after a route change for the destination page
// to mount before reporting completion. Shared across navigate tool definitions.
export const NAVIGATION_SETTLE_MS = 800

export function delay(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, ms)
  })
}

export async function pollUntil<T extends Element>(
  check: () => T | null,
  retriesLeft: number = ELEMENT_RETRY_COUNT
): Promise<T | null> {
  if (retriesLeft <= 0) return null
  const el = check()
  if (el) return el
  await delay(ELEMENT_RETRY_DELAY_MS)
  return pollUntil(check, retriesLeft - 1)
}

/**
 * Looks up an element by its data-agent-id attribute, polling for it to appear
 * if it is not present immediately.
 */
export function findElement(agentId: string): Promise<Element | null> {
  return pollUntil(() => document.querySelector(`[data-agent-id="${agentId}"]`))
}
